<template>
  <div id="app">
    <topbar />

    <router-view></router-view>
  </div>
</template>

<script>
import topbar from './components/layout/topbar.vue'

export default {
  name: 'App',
  components: {
    topbar
  }
}
</script>

<style>
#app {}
</style>
